import React from 'react';
import type { VoiceCloneStatus } from '../../../types/voice';

const STATUS_CONFIG: Record<VoiceCloneStatus, { label: string; color: string }> = {
  recording: { label: 'Recording', color: 'bg-yellow-100 text-yellow-800' },
  uploading: { label: 'Uploading', color: 'bg-blue-100 text-blue-800' },
  creating: { label: 'Creating...', color: 'bg-blue-100 text-blue-800' },
  ready: { label: 'Ready', color: 'bg-green-100 text-green-800' },
  failed: { label: 'Failed', color: 'bg-red-100 text-red-800' },
};

interface VoiceStatusBadgeProps {
  status: VoiceCloneStatus;
}

export function VoiceStatusBadge({ status }: VoiceStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
      {status === 'creating' && (
        <span className="w-2 h-2 mr-1.5 rounded-full bg-blue-400 animate-pulse" />
      )}
      {status === 'ready' && (
        <span className="w-2 h-2 mr-1.5 rounded-full bg-green-400" />
      )}
      {config.label}
    </span>
  );
}
